import React from 'react';
import { useTranslations } from '@unisporkal/localization';
import {
  AlignItemsEnum,
  Flex,
  FlexDirectionEnum,
  Typography,
  TypographyComponentEnum,
  TypographyVariant,
} from '@unisporkal/alliance-ui';

import AgencyUnlimitedIcon from '../../../../icons/AgencyUnlimitedIcon';
import styles from './UnlimitedContentMessage.module.scss';

const UnlimitedContentMessage: React.FC<{
  buyCardMessageText: React.ReactNode;
}> = ({ buyCardMessageText }) => {
  const t = useTranslations();

  return (
    <Flex
      alignItems={AlignItemsEnum.FLEXSTART}
      flexDirection={FlexDirectionEnum.ROW}
      className={styles.unlimitedContentContainer}
      data-testid="unlimited-content-message"
    >
      <div className={styles.iconContainer}>
        <AgencyUnlimitedIcon />
      </div>
      <div className={styles.content}>
        <Typography
          variant={TypographyVariant.title.small}
          component={TypographyComponentEnum.DIV}
          className={styles.title}
          data-testid="unlimited-content-title"
        >
          {t('included_unlimited_content_plan')}
        </Typography>
        <Typography
          variant={TypographyVariant.body.small}
          component={TypographyComponentEnum.DIV}
          className={styles.buyCardMessage}
        >
          {buyCardMessageText}
        </Typography>
      </div>
    </Flex>
  );
};

export default UnlimitedContentMessage;
